

export default {
  name: 'EoLogoBijbelopen',
  props: {
    /**
     * Style: hex value of color
     */
    color: {
      type: String,
      default: '',
    },
  },
}
